import { Box, Stack } from '@mui/material';
import { useState, useCallback } from 'react';
import { HeaderMobileToggleButton } from '@/components/content/Header/parts/MobileToggleButton';
import { HeaderMobileDrawer } from '@/components/content/Header/parts/MobileDrawer';
import { SearchMobileDrawer } from '@/components/content/Header/parts/MobileDrawerSearch';
import { HeaderMiniCart } from '@/components/content/Header/parts/MiniCart';
import { HeaderSearch } from '@/components/content/Header/parts/HeaderSearch';
import { ID } from '@/data/types/Basic';
import { ShortHeaderLogo } from '@/components/content/ShortHeader/parts/HeaderLogo';

export const HeaderNavBarMobile: React.FC<{
	id: ID;
	navBarRecommendation: JSX.Element;
}> = ({ navBarRecommendation }) => {
	const [drawerOpen, setDrawerOpen] = useState(false);
	const [searchDrawerOpen, setSearchOpen] = useState(false);

	const toggleDrawer = useCallback(
		(open?: boolean) => () => {
			setDrawerOpen(open !== undefined ? open : (current) => !current);
		},
		[]
	);

	const toggleDrawerSearch = useCallback(
		(open?: boolean) => () => {
			setSearchOpen(open !== undefined ? open : (current) => !current);
		},
		[]
	);

	return (
		<Box display="flex" justifyContent="center" alignItems="center" width="100%" height="100%">
			<Stack
				width="100%"
				direction="row"
				alignItems="center"
				justifyContent="space-between"
				spacing={2}
				px={2}
				py={1}
			>
				<ShortHeaderLogo />
				<Stack direction="row" spacing={1} display="flex" alignItems="center">
					<HeaderSearch toggleSearch={toggleDrawerSearch} />
					<SearchMobileDrawer
						toggleSearch={toggleDrawerSearch}
						open={searchDrawerOpen}
						navBarRecommendation={navBarRecommendation}
					/>
					<HeaderMiniCart mobileBreakpoint="xs" />
					<HeaderMobileToggleButton toggleDrawer={toggleDrawer} open={drawerOpen} />
					<HeaderMobileDrawer toggleDrawer={toggleDrawer} open={drawerOpen} />
				</Stack>
			</Stack>
		</Box>
	);
};
